import { defineStore } from 'pinia'
import { api } from '@/api'

export interface INotifyState {
  websocketId?: string // 预留
  count: number // 未读消息数量
}

export const useNotifyStore = defineStore('useNotifyStore', {
  state: (): INotifyState => {
    return {
      websocketId: undefined,
      count: 0,
    }
  },
  actions: {
    UPDATE_UNREAD_COUNT(count: number) {
      this.count = count
    },
    UPDATE_WEBSOCKET_ID(websocketId: string) {
      this.websocketId = websocketId
    },
    async updateUnreadCount() {
      const res: any = await api.get('/api/Notify/UnReadedCount')
      this.UPDATE_UNREAD_COUNT(res.data.count)
      return res.data
    },
  },
  getters: {
    unreadCount: (state: INotifyState) => state.count,
    websocketId: (state: INotifyState) => state.websocketId,
  },
})
